import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-24 min-h-[70vh] flex items-center justify-center" data-testid="payment-cancel">
      <div className="panel p-10 max-w-md w-full text-center">
        <XCircle className="w-14 h-14 text-rose-400 mx-auto" />
        <h1 className="font-display text-3xl font-bold text-white mt-4">Ödeme iptal edildi</h1>
        <p className="text-slate-400 mt-3">Ödeme adımını tekrar başlatabilirsiniz.</p>
        <Link to="/dashboard" className="btn-cyan mt-6 inline-block">Panele Git</Link>
      </div>
    </main>
  );
}
